<template>
    <div class="pricing-table-wrap pt-100 pb-75">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="pricing-table style1">
                        <div class="pricing-header">
                            <h2><img src="../../assets/images/pricing-star.png" alt="Image">Local Transactions</h2>
                            <div class="pricing-header-tag">
                                <h3><span>Registration</span><span>Mobile Money</span><span>Fidelity Cards</span></h3>
                                
                            </div>
                        </div>
                        <div class="pricing-features">
                            <ul class="list-style">
                                <li class="checked"><i class="ri-check-line"></i>Local and International payments</li>
                                <li class="checked"><i class="ri-check-line"></i>Unlimited Transaction Volumes</li>
                                <li class="checked"><i class="ri-check-line"></i>Cash In and Cash Out</li>
                                <li class="checked"><i class="ri-check-line"></i>Unlimited Transaction Volumes</li>
                                <li class="checked"><i class="ri-check-line"></i>Multi-currency transaction requests</li>
                                <li class="unchecked"><i class="ri-close-line"></i>Currency Conversion Fees</li>
                                <li class="unchecked"><i class="ri-close-line"></i>Lower transaction Fees</li>
                                <li class="checked"><i class="ri-check-line"></i>24/7 Support</li>
                            </ul>
                        </div>

                        <div class="purchase-pricing">
                            <router-link to="/contact" class="btn style1">Contact us</router-link>
                        </div>
                    </div>
                </div>

                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="pricing-table style2">
                        <div class="pricing-header">
                            <h2><img src="../../assets/images/pricing-star.png" alt="Image">Merchant Local Account </h2>
                            <div class="pricing-header-tag">
                                <h3><span>Mobile Money Payment</span><span>Credit Card</span></h3>
                            </div>
                            <!--<span class="feature-tag">Most Popular</span>-->
                        </div>
                        <div class="pricing-features">
                            <ul class="list-style">
                                <li class="checked"><i class="ri-check-line"></i>Local and International payments</li>
                                <li class="checked"><i class="ri-check-line"></i>Unlimited Transaction Volumes</li>
                                <li class="checked"><i class="ri-check-line"></i>Local Settlement</li>
                                <li class="checked"><i class="ri-check-line"></i>Unlimited Transaction Volumes</li>
                                <li class="checked"><i class="ri-check-line"></i>Multi-currency transaction requests</li>
                                <li class="unchecked"><i class="ri-close-line"></i>Currency Conversion Fees</li>
                                <li class="checked"><i class="ri-check-line"></i>Lower transaction Fees</li>                               
                                <li class="checked"><i class="ri-check-line"></i>24/7 Support</li>
                            </ul>
                        </div>
                        <div class="purchase-pricing">
                            <router-link to="/contact" class="btn style1">Contact us</router-link>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="pricing-table style1">
                        <div class="pricing-header">
                            <h2><img src="../../assets/images/pricing-star.png" alt="Image">Merchant International Account</h2>
                            <div class="pricing-header-tag">
                                <h3><span>Mobile Money Payment</span><span>Credit Card</span></h3>
                            </div>
                        </div>
                        <div class="pricing-features">
                            <ul class="list-style">
                                <li class="checked"><i class="ri-check-line"></i>Local and International payments</li>
                                <li class="checked"><i class="ri-check-line"></i>Unlimited Transaction Volumes</li>
                                <li class="checked"><i class="ri-check-line"></i>Loca and International Settlement</li>
                                <li class="checked"><i class="ri-check-line"></i>Unlimited Transaction Volumes</li>
                                <li class="checked"><i class="ri-check-line"></i>Multi-currency transaction requests</li>
                                <li class="checked"><i class="ri-check-line"></i>Currency Conversion Fees</li>
                                <li class="checked"><i class="ri-check-line"></i>Lower transaction Fees</li>
                                <li class="checked"><i class="ri-check-line"></i>24/7 Support</li>
                            </ul>
                        </div>
                        <div class="purchase-pricing">
                            <router-link to="/contact" class="btn style1">Contact us</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Pricing'
}
</script>